import React, {useCallback, useEffect, useRef} from 'react'

export const  useInfiniteScroll=(fetchItems, hasMore)=>{
    const LoadRef = useRef(null);
    const HandleIntersection = useCallback((entries)=>{
        const isIntersecting = entries[0]?.isIntersecting;
        if(isIntersecting && hasMore)
            fetchItems()
    },[fetchItems,hasMore]);

    useEffect(()=>{
        const observer = new IntersectionObserver(HandleIntersection);
        if(LoadRef.current)
            observer.observe(LoadRef.current);
        return ()=>observer.disconnect();
    },[HandleIntersection]);

  return LoadRef;
}

